import React, { useState, useEffect } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
	TextField,
	Button,
	MenuItem,
	IconButton,
	Grid,
	Container,
	Paper,
	Box,
	Typography, AppBar, Toolbar, InputAdornment,
	Modal,
	Select,
	InputLabel,
	FormControl,
	CircularProgress,
	Tooltip,
	Divider,
	Chip,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Alert = React.forwardRef(function Alert(props, ref) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditUser = () => {
	const navigate = useNavigate();
	const { userId } = useParams();
	const [searchParams] = useSearchParams();
const branchIdFromQuery = searchParams.get("Branch_Id");

const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(null);



	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState("");
	const [snackbarSeverity, setSnackbarSeverity] = useState("success");
	const [modalOpen, setModalOpen] = useState(false);
	const [modalMessage, setModalMessage] = useState("");
	const [modalType, setModalType] = useState("success");
	const [showPassword, setShowPassword] = useState(false);

	// Info modal state
	const [infoModalOpen, setInfoModalOpen] = useState(false);

	// Form fields
	const [userRole, setUserRole] = useState("");
	const [userGroupId, setUserGroupId] = useState(null); // ← Critical: for payload
	const [department, setDepartment] = useState("");
	const [employeeId, setEmployeeId] = useState("");
	const [employeeNameDisplay, setEmployeeNameDisplay] = useState("");
	const [userName, setUserName] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [expiryDate, setExpiryDate] = useState("");
	const [passwordError, setPasswordError] = useState("");

	// Data from API
	const [employees, setEmployees] = useState([]);
	const [userGroups, setUserGroups] = useState([]); // Filtered allowed groups
	const [departments, setDepartments] = useState([]);
	const [loading, setLoading] = useState(true);

	const validatePassword = (pwd) => {
		if (pwd.length < 8) return "Password must be at least 8 characters long.";
		if (!/[!@#$%^&*]/.test(pwd))
			return "Password must contain at least one special character.";
		return "";
	};

	const fetchDepartments = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${apiUrl}/Department/DepartmentName`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      }
    );
    if (response.ok) {
      const data = await response.json();
      // Extract department names only
      const departmentNames = Array.isArray(data)
        ? data.map((dept) => dept.departmentName).filter(Boolean)
        : [];
      setDepartments(departmentNames);
    }
  } catch (error) {
    console.error("Error fetching departments:", error);
  }
};


	const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  // Set the branchId from query parameter or sessionStorage
  const branchId = branchIdFromQuery || sessionStorage.getItem("branchId");
  setSelectedBranchId(branchId);

  if (isMasterUser) {
    fetchBranches();
  }
}, [branchIdFromQuery]);



	useEffect(() => {
		const fetchAllData = async () => {
			try {
				setLoading(true);
				const apiUrl = process.env.REACT_APP_BASE_URL;
				const token = sessionStorage.getItem("token");
 const branchId = isMaster ? selectedBranchId : branchIdFromQuery || sessionStorage.getItem("branchId");
				// 1. Fetch employees
				const empRes = await fetch(`${apiUrl}/Employee/GetEmployee?Branch_Id=${branchId}`, {
        method: "POST",
					headers: { "Content-Type": "application/json", Authorization: token },
					body: JSON.stringify({}),
				});
				if (!empRes.ok) throw new Error("Failed to fetch employees");
				const empData = await empRes.json();
const employeeList = Array.isArray(empData)
  ? empData
  : empData?.data || empData?.result || [];

setEmployees(employeeList);

				// Fetch departments (NEW)
      await fetchDepartments();

				// 2. Fetch user groups
				 const groupRes = await fetch(`${apiUrl}/CPanel/GetUserGroup?Branch_Id=${branchId}`, {
        method: "POST",
					headers: { "Content-Type": "application/json", Authorization: token },
					body: JSON.stringify({
						userGroupId: 0,
						operation: "Other",
						userType: sessionStorage.getItem("userType"),
					}),
				});

				let filteredGroups = [];
				if (groupRes.ok) {
					const groupData = await groupRes.json();
					filteredGroups = (groupData || []).filter((group) => {
						const name = (group.userGroupName || "").trim().toLowerCase();
						return name !== "parent" && name !== "student";
					});
				}
				setUserGroups(filteredGroups);

				// 3. Fetch users list
				const userRes = await fetch(`${apiUrl}/CPanel/GetUser?Branch_Id=${branchId}`, {
        method: "POST",
					headers: { "Content-Type": "application/json", Authorization: token },
				});
				if (!userRes.ok) throw new Error("Failed to fetch users");
				const usersData = await userRes.json();

				const currentUser = usersData.find(
					(u) => u.userId === parseInt(userId)
				);
				if (!currentUser) {
					setSnackbarMessage("User not found");
					setSnackbarSeverity("error");
					setOpenSnackbar(true);
					return;
				}

				// Set basic fields
				setUserName(currentUser.userName || "");
				setPassword(currentUser.password || "");
				setConfirmPassword(currentUser.password || "");
				setExpiryDate(
					currentUser.expiryDate
						? currentUser.expiryDate.split("/").reverse().join("-")
						: ""
				);

				// Set role & group ID
				const matchedGroup = filteredGroups.find(
					(g) =>
						(g.userGroupName || "").trim() ===
						(currentUser.userGroupName || "").trim()
				);

				if (matchedGroup) {
					setUserRole(matchedGroup.userGroupName);
					setUserGroupId(matchedGroup.userGroupId);
				} else {
					// Legacy/forbidden role (e.g. parent/student)
					setUserRole(currentUser.userGroupName || "");
					setUserGroupId(null); // Will be validated before submit
				}

				// Match employee
				const matchedEmp = empData.find(
					(e) =>
						(e.employeeName || "").trim() ===
						(currentUser.employeeName || "").trim()
				);
				if (matchedEmp) {
					setEmployeeId(matchedEmp.employeeID.toString());
					setDepartment(matchedEmp.departmentName || "");
					setEmployeeNameDisplay(
						`${matchedEmp.employeeName} (${matchedEmp.employeeCode || "-"})`
					);
				} else {
					setEmployeeNameDisplay(currentUser.employeeName || "Not found");
				}
			} catch (error) {
				console.error("Error loading data:", error);
				setSnackbarMessage("Failed to load user data");
				setSnackbarSeverity("error");
				setOpenSnackbar(true);
			} finally {
				setLoading(false);
			}
		};

		fetchAllData();
	}, [userId, selectedBranchId]);

	// Filtered employees
	const filteredEmployees = employees.filter((emp) => {
		const roleMatch =
			!userRole ||
			emp.departmentName?.toLowerCase().includes(userRole.toLowerCase()) ||
			(userRole === "Teacher" && emp.departmentName === "Teacher") ||
			(userRole === "Accountant" && emp.departmentName === "Account") ||
			(userRole === "Driver" && emp.departmentName === "Driver");

		const deptMatch = !department || emp.departmentName === department;

		return roleMatch && deptMatch;
	});

	const handleUpdate = async () => {
		if (password !== confirmPassword) {
			setSnackbarMessage("Passwords do not match");
			setSnackbarSeverity("error");
			setOpenSnackbar(true);
			return;
		}

		const pwdError = validatePassword(password);
		if (pwdError) {
			setPasswordError(pwdError);
			return;
		}

		if (!userGroupId) {
			setSnackbarMessage("Please select a valid user role");
			setSnackbarSeverity("error");
			setOpenSnackbar(true);
			return;
		}

		try {
			const apiUrl = process.env.REACT_APP_BASE_URL;
			const token = sessionStorage.getItem("token");
			const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

			const formattedDate = expiryDate
				? expiryDate.split("-").reverse().join("/")
				: "";

			const payload = {
				userGroupId: userGroupId, // ← Correct value!
				password,
				expiryDate: formattedDate,
			};

			const response = await fetch(`${apiUrl}/CPanel/UserId?UserId=${userId}&Branch_Id=${branchId}`, {
				method: "PUT",
				headers: { "Content-Type": "application/json", Authorization: token },
				body: JSON.stringify(payload),
			});

			const data = await response.json();
			const message = (data && (data.msg || data.message)) || "User has been updated successfully.";
			const status = (data && data.status && data.status.toString().toLowerCase()) || "";
			const lowerMsg = (message || "").toString().toLowerCase();
			const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
			const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

			setModalType(messageHasError ? 'error' : 'success');
			setModalMessage(message);
			setModalOpen(true);
		} catch (error) {
			console.error("Update error:", error);
			setSnackbarMessage("An error occurred while updating");
			setSnackbarSeverity("error");
			setOpenSnackbar(true);
		}
	};

	const handleCancel = () => navigate(-1);
	const togglePasswordVisibility = () => setShowPassword(!showPassword);

	// Helper: get selected branch name for info modal
	const getSelectedBranchName = () => {
		if (!selectedBranchId) return "N/A";
		const found = branches.find(
			(b) => b.branchId === selectedBranchId || b.branchId === parseInt(selectedBranchId)
		);
		return found ? found.branchName : selectedBranchId;
	};

	// Helper: format expiry date for display
	const getFormattedExpiryDate = () => {
		if (!expiryDate) return "N/A";
		// expiryDate is stored as YYYY-MM-DD, convert to DD/MM/YYYY for display
		const parts = expiryDate.split("-");
		if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
		return expiryDate;
	};

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="60vh"
			>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Container maxWidth="md">
			{/* Header */}
			   <AppBar
  position="static"
  sx={{
    backgroundColor: "#0B1F3D",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    mb:1
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
    
    {/* Left: Title */}
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        letterSpacing: "0.5px",
        color: "#ffffff",
      }}
    >
     Edit User
    </Typography>

    {/* Right: Branch Dropdown */}
   {isMaster && (
  <Box sx={{ position: "relative" }}>
    <FormControl size="small" sx={{ width: 220 }} disabled>
      <InputLabel
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          top: "-2px",
          "&.Mui-focused": { color: "#64B5F6" },
          "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
        }}
      >
        Branch
      </InputLabel>
      <Select
        value={selectedBranchId || ""}
        onChange={(e) => setSelectedBranchId(e.target.value)}
        label="Branch"
        startAdornment={
          <InputAdornment position="start">
            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
          </InputAdornment>
        }
        sx={{
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.3px",
          backgroundColor: "rgba(255,255,255,0.07)",
          backdropFilter: "blur(8px)",
          borderRadius: "8px",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",

		  "& .MuiSelect-select.Mui-disabled": {
  color: "#ffffff !important",
  WebkitTextFillColor: "#ffffff !important",
},

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.15)",
            borderWidth: "1px",
            transition: "border-color 0.2s ease",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.11)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.35)",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.1)",
            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#64B5F6",
              borderWidth: "1.5px",
            },
          },
          "& .MuiSelect-icon": {
            color: "rgba(255,255,255,0.5)",
            transition: "color 0.2s ease",
          },
          "&.Mui-focused .MuiSelect-icon": {
            color: "#64B5F6",
          },
          "& .MuiSelect-select": {
            py: 1.1,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "10px",
              border: "1px solid rgba(11,31,61,0.12)",
              boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.5 },
            },
          },
        }}
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.branchId}
            value={branch.branchId}
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#0B1F3D",
              px: 2,
              py: 1.1,
              mx: 0.5,
              borderRadius: "6px",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "rgba(11,31,61,0.07)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(25,118,210,0.1)",
                color: "#1565C0",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(25,118,210,0.15)",
                },
              },
            }}  
          >
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
)}
  </Toolbar>
</AppBar>

			<Paper elevation={3} sx={{ p: 4, borderRadius: "0 0 4px 4px" }}>
				<Grid container spacing={3}>
					{/* User Role */}
					<Grid item xs={12} sm={6}>
						<FormControl fullWidth>
							<InputLabel>User Role</InputLabel>
							<Select
								value={userRole}
								label="User Role"
								onChange={(e) => {
									const newRoleName = e.target.value;
									if (
										["parent", "student"].includes(newRoleName.toLowerCase())
									) {
										return; // Prevent selecting forbidden roles
									}

									const selectedGroup = userGroups.find(
										(g) => g.userGroupName === newRoleName
									);

									if (selectedGroup) {
										setUserGroupId(selectedGroup.userGroupId);
										setUserRole(newRoleName);
										setDepartment("");
										setEmployeeId("");
									}
								}}
							>
								{/* Show current forbidden role if exists */}
								{userRole &&
									["parent", "student"].includes(userRole.toLowerCase()) && (
										<MenuItem value={userRole} disabled>
											{userRole} (not allowed to change)
										</MenuItem>
									)}

								{userGroups.map((role) => (
									<MenuItem key={role.userGroupId} value={role.userGroupName}>
										{role.userGroupName}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>

					{/* Department */}
					<Grid item xs={12} sm={6}>
						<FormControl fullWidth>
							<InputLabel>Department</InputLabel>
							<Select
								value={department}
								label="Department"
								onChange={(e) => {
									setDepartment(e.target.value);
									setEmployeeId("");
								}}
							>
								<MenuItem value="">
									<em>Any / All</em>
								</MenuItem>
								{departments.map((dept) => (
									<MenuItem key={dept} value={dept}>
										{dept}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>

					{/* Employee Name */}
<Grid item xs={12}>
  <FormControl fullWidth>
    <InputLabel>Employee</InputLabel>
    <Select
      value={employeeId}
      label="Employee"
      onChange={(e) => {
        const selected = e.target.value;
        setEmployeeId(selected);
        if (selected) {
          const emp = employees.find(
            (em) => em.employeeID.toString() === selected
          );
          if (emp) {
            setEmployeeNameDisplay(
              `${emp.employeeName} (${emp.employeeCode || "-"})`
            );
          }
        } else {
          setEmployeeNameDisplay("");
        }
      }}
      renderValue={(selected) => {
        if (selected) {
          const emp = employees.find(
            (em) => em.employeeID.toString() === selected
          );
          if (emp) {
            return `${emp.employeeName} (${emp.employeeCode || "-"}) `;
          }
        }
        // If no selection (or cleared), show the pre-loaded display name (for legacy/not-found cases)
        return employeeNameDisplay || <em>Select Employee</em>;
      }}
    >
      {filteredEmployees.map((emp) => (
        <MenuItem
          key={emp.employeeID}
          value={emp.employeeID.toString()}
        >
          {emp.employeeName} ({emp.employeeCode || "-"}) -{" "}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>

					{/* Username (read-only) */}
					<Grid item xs={12} sm={6}>
						<TextField
							label="Username"
							fullWidth
							value={userName}
							InputProps={{ readOnly: true }}
						/>
					</Grid>

					{/* Password */}
					<Grid item xs={12} sm={6}>
						<TextField
							label="Password"
							type={showPassword ? "text" : "password"}
							fullWidth
							value={password}
							onChange={(e) => {
								setPassword(e.target.value);
								setPasswordError(validatePassword(e.target.value));
							}}
							error={!!passwordError}
							helperText={passwordError}
							InputProps={{
								endAdornment: (
									<IconButton onClick={togglePasswordVisibility}>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								),
							}}
						/>
					</Grid>

					{/* Confirm Password */}
					<Grid item xs={12} sm={6}>
						<TextField
							label="Confirm Password"
							type={showPassword ? "text" : "password"}
							fullWidth
							value={confirmPassword}
							onChange={(e) => setConfirmPassword(e.target.value)}
							error={password !== confirmPassword && confirmPassword !== ""}
							helperText={
								password !== confirmPassword && confirmPassword !== ""
									? "Passwords do not match"
									: ""
							}
							InputProps={{
								endAdornment: (
									<IconButton onClick={togglePasswordVisibility}>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								),
							}}
						/>
					</Grid>

					{/* Expiry Date */}
					<Grid item xs={12} sm={6}>
						<TextField
							label="Expiry Date"
							type="date"
							fullWidth
							value={expiryDate}
							onChange={(e) => setExpiryDate(e.target.value)}
							InputLabelProps={{ shrink: true }}
						/>
					</Grid>

					{/* Buttons */}
					<Grid item xs={12}>
						<Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} mt={3}>
							{/* ℹ Info Button */}
							<Tooltip title="View full user details" arrow>
								<IconButton
									onClick={() => setInfoModalOpen(true)}
									sx={{
										backgroundColor: "#e3f2fd",
										color: "#1565C0",
										border: "1.5px solid #90caf9",
										borderRadius: "8px",
										width: 40,
										height: 40,
										"&:hover": {
											backgroundColor: "#bbdefb",
											borderColor: "#1565C0",
											boxShadow: "0 2px 8px rgba(21,101,192,0.18)",
										},
										transition: "all 0.2s ease",
									}}
								>
									<InfoOutlinedIcon fontSize="small" />
								</IconButton>
							</Tooltip>

							<Button
								variant="contained"
								color="primary"
								onClick={handleUpdate}
								sx={{ minWidth: 100 }}
							>
								UPDATE
							</Button>
							<Button
								variant="contained"
								color="error"
								onClick={handleCancel}
								sx={{ minWidth: 100 }}
							>
								CANCEL
							</Button>
						</Box>
					</Grid>
				</Grid>
			</Paper>

{/* Modal */}
		<Modal
			open={modalOpen}
			onClose={() => setModalOpen(false)}
			aria-labelledby="modal-title"
		>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: 400,
					bgcolor: "background.paper",
					borderRadius: 2,
					boxShadow: 24,
					overflow: "hidden",
				}}
			>
				<Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', p: 2 }}>
					<Typography id="modal-title" variant="h6" sx={{ color: "#fff" }}>
						{modalType === 'error' ? 'Error ❌' : 'User Updated ✅'}
					</Typography>
				</Box>
				<Box sx={{ p: 3 }}>
					<Typography>{modalMessage || 'Operation completed.'}</Typography>
					<Box sx={{ mt: 3, textAlign: "right" }}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => {
								setModalOpen(false);
								if (modalType !== 'error') navigate(-1);
								}}
							>
								OK
							</Button>
						</Box>
					</Box>
				</Box>
			</Modal>

			{/* Info Detail Modal */}
			<Modal
				open={infoModalOpen}
				onClose={() => setInfoModalOpen(false)}
				aria-labelledby="info-modal-title"
			>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: { xs: "92%", sm: 480 },
						bgcolor: "background.paper",
						borderRadius: 2,
						boxShadow: "0 8px 40px rgba(11,31,61,0.18)",
						overflow: "hidden",
					}}
				>
					{/* Info Modal Header */}
					<Box
						sx={{
							backgroundColor: "#0B1F3D",
							px: 3,
							py: 2,
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Box display="flex" alignItems="center" gap={1}>
							<InfoOutlinedIcon sx={{ color: "#64B5F6", fontSize: 22 }} />
							<Typography
								id="info-modal-title"
								variant="h6"
								sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.3 }}
							>
								User Details
							</Typography>
						</Box>
						<Chip
							label={`ID: ${userId}`}
							size="small"
							sx={{
								backgroundColor: "rgba(100,181,246,0.18)",
								color: "#64B5F6",
								fontWeight: 600,
								fontSize: "0.75rem",
								border: "1px solid rgba(100,181,246,0.35)",
							}}
						/>
					</Box>

					{/* Info Modal Body */}
					<Box sx={{ p: 3 }}>
						{/* Section: Account Info */}
						<Typography
							variant="overline"
							sx={{ color: "#1565C0", fontWeight: 700, letterSpacing: 1 }}
						>
							Account Information
						</Typography>
						<Divider sx={{ mb: 1.5, mt: 0.5 }} />
						<Grid container spacing={1.5} sx={{ mb: 2 }}>
							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Username
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Typography variant="body2" fontWeight={500}>
									{userName || "N/A"}
								</Typography>
							</Grid>

							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									User Role
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Chip
									label={userRole || "N/A"}
									size="small"
									sx={{
										backgroundColor:
											userRole
												? "rgba(21,101,192,0.1)"
												: "rgba(0,0,0,0.06)",
										color: userRole ? "#1565C0" : "text.secondary",
										fontWeight: 600,
										fontSize: "0.75rem",
									}}
								/>
							</Grid>

							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									User Group ID
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Typography variant="body2" fontWeight={500}>
									{userGroupId ?? "N/A"}
								</Typography>
							</Grid>

							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Expiry Date
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Typography
									variant="body2"
									fontWeight={500}
									sx={{
										color: expiryDate ? "text.primary" : "text.disabled",
									}}
								>
									{getFormattedExpiryDate()}
								</Typography>
							</Grid>
						</Grid>

						{/* Section: Employee Info */}
						<Typography
							variant="overline"
							sx={{ color: "#1565C0", fontWeight: 700, letterSpacing: 1 }}
						>
							Employee Information
						</Typography>
						<Divider sx={{ mb: 1.5, mt: 0.5 }} />
						<Grid container spacing={1.5} sx={{ mb: 2 }}>
							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Employee Name
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Typography variant="body2" fontWeight={500}>
									{employeeNameDisplay || "N/A"}
								</Typography>
							</Grid>

							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Employee ID
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Typography variant="body2" fontWeight={500}>
									{employeeId || "N/A"}
								</Typography>
							</Grid>

							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Department
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Typography variant="body2" fontWeight={500}>
									{department || "Any / All"}
								</Typography>
							</Grid>
						</Grid>

						{/* Section: Branch Info (visible to master users) */}
						{isMaster && (
							<>
								<Typography
									variant="overline"
									sx={{ color: "#1565C0", fontWeight: 700, letterSpacing: 1 }}
								>
									Branch Information
								</Typography>
								<Divider sx={{ mb: 1.5, mt: 0.5 }} />
								<Grid container spacing={1.5} sx={{ mb: 2 }}>
									<Grid item xs={5}>
										<Typography variant="body2" color="text.secondary" fontWeight={600}>
											Branch Name
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography variant="body2" fontWeight={500}>
											{getSelectedBranchName()}
										</Typography>
									</Grid>
									<Grid item xs={5}>
										<Typography variant="body2" color="text.secondary" fontWeight={600}>
											Branch ID
										</Typography>
									</Grid>
									<Grid item xs={7}>
										<Typography variant="body2" fontWeight={500}>
											{selectedBranchId || "N/A"}
										</Typography>
									</Grid>
								</Grid>
							</>
						)}

						{/* Section: Password Status */}
						<Typography
							variant="overline"
							sx={{ color: "#1565C0", fontWeight: 700, letterSpacing: 1 }}
						>
							Password Status
						</Typography>
						<Divider sx={{ mb: 1.5, mt: 0.5 }} />
						<Grid container spacing={1.5} sx={{ mb: 1 }}>
							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Strength
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Chip
									label={
										!password
											? "Not Set"
											: validatePassword(password) === ""
											? "Strong ✓"
											: "Weak ✗"
									}
									size="small"
									sx={{
										backgroundColor:
											!password
												? "rgba(0,0,0,0.06)"
												: validatePassword(password) === ""
												? "rgba(46,125,50,0.1)"
												: "rgba(198,40,40,0.1)",
										color:
											!password
												? "text.secondary"
												: validatePassword(password) === ""
												? "#2E7D32"
												: "#C62828",
										fontWeight: 700,
										fontSize: "0.75rem",
									}}
								/>
							</Grid>

							<Grid item xs={5}>
								<Typography variant="body2" color="text.secondary" fontWeight={600}>
									Match
								</Typography>
							</Grid>
							<Grid item xs={7}>
								<Chip
									label={
										!confirmPassword
											? "—"
											: password === confirmPassword
											? "Passwords Match ✓"
											: "Mismatch ✗"
									}
									size="small"
									sx={{
										backgroundColor:
											!confirmPassword
												? "rgba(0,0,0,0.06)"
												: password === confirmPassword
												? "rgba(46,125,50,0.1)"
												: "rgba(198,40,40,0.1)",
										color:
											!confirmPassword
												? "text.secondary"
												: password === confirmPassword
												? "#2E7D32"
												: "#C62828",
										fontWeight: 700,
										fontSize: "0.75rem",
									}}
								/>
							</Grid>
						</Grid>
					</Box>

					{/* Info Modal Footer */}
					<Box
						sx={{
							px: 3,
							py: 2,
							borderTop: "1px solid rgba(0,0,0,0.08)",
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<Button
							variant="contained"
							onClick={() => setInfoModalOpen(false)}
							sx={{
								backgroundColor: "#0B1F3D",
								"&:hover": { backgroundColor: "#1a3a6b" },
								minWidth: 80,
								borderRadius: "8px",
								fontWeight: 600,
							}}
						>
							Close
						</Button>
					</Box>
				</Box>
			</Modal>

			{/* Snackbar */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={5000}
				onClose={() => setOpenSnackbar(false)}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert
					onClose={() => setOpenSnackbar(false)}
					severity={snackbarSeverity}
				>
					{snackbarMessage}
				</Alert>
			</Snackbar>
		</Container>
	);
};

export default EditUser;